module.exports = __webpack_public_path__ + "static/media/feature-img.7e05b101.svg";